// Context-aware WhatsApp Click-to-Chat message builder.

const PHONE = "4917652891700";

const DEFAULT_MESSAGE = "Hello, as a company I would like to ask how you can help us immediately.";

const MESSAGES: Record<string, string> = {
  "/":
    "Hello, I am an IT/SAP consultant and would like to learn how OXORY places me into suitable projects.",
  "/contact":
    "Hello, I found your contact page and would like to get in touch with OXORY about a project.",
  "/services/technology-consulting":
    "Hello, I saw your SAP Technology Consulting page and have a question about our SAP project.",
  "/services/ams":
    "Hello, I am interested in your Application Management Services and would like to know more about your AMS support.",
  "/shoring":
    "Hello, I am interested in your Shoring services and would like to know more about nearshore delivery.",
  "/about":
    "Hello, I read about OXORY and would like to know more about your company and expertise.",
  "/solutions": "Hello, I saw your solutions page and would like to discuss how OXORY can help.",
  "/services":
    "Hello, I saw your services page and would like to know more about how OXORY can support us.",
};

export interface WhatsAppUrlOptions {
  utmContent?: string;
}

export function whatsappUrl(pathname: string, options?: WhatsAppUrlOptions): string {
  // Exact match first, then fallback to a parent prefix if available.
  const message = MESSAGES[pathname] ?? DEFAULT_MESSAGE;
  const encoded = encodeURIComponent(message);
  const utm = new URLSearchParams({
    utm_source: "oxory.net",
    utm_medium: "whatsapp",
    utm_campaign: "talk_to_us",
  });
  if (options?.utmContent) {
    utm.set("utm_content", options.utmContent);
  }
  return `https://wa.me/${PHONE}?text=${encoded}&${utm.toString()}`;
}
